import React from "react";
import { SponsorInformationContainer } from "../../../containers";

const SponsorInformation = (props) => {
  return <SponsorInformationContainer {...props} />;
};

export default SponsorInformation;
